import { render, staticRenderFns } from "./facility-status.vue?vue&type=template&id=86630c72"
import script from "./facility-status.vue?vue&type=script&lang=js"
export * from "./facility-status.vue?vue&type=script&lang=js"
import style0 from "./facility-status.vue?vue&type=style&index=0&id=86630c72&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports